import React from 'react';
import { View, StyleSheet, Text, Pressable, InteractionManager } from 'react-native';

import {
  OPComponent,
  Container,
  TabMenu,
  NavBar,
  I18n,
  Utils,
  Navigation,
  CheckButtonList,
  NextButton,
  FormInput,
} from '../components';

import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../constants/styles';
import { BENEFICIARY } from '../../constants/patientRoles';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ResidentSelect from './resident_select';

import { getCasesForEmployer } from '../../selectors/cases';
import {
  getGroupedPatientsForEmployer,
  getGroupedPatientsByTaskingIdForEmployer,
  getGroupsForEmployer,
} from '../../selectors/employers';
import { setCalendarSelectedCases } from '../calendar/actions';
import { caseInfoChanged } from '../cases/actions';

const AIRMAN_INDEX = 0;
const GROUPS_INDEX = 1;
const TASKINGID_INDEX = 2;

import { EVENT_TYPE_AIRFORCE_DEPLOYMENT } from '../../constants/eventTypes';

class SelectCases extends OPComponent {
  static options(passProps) {
    return {
      topBar: {
        leftButtons: [NavBar.buttons.cancel],
      },
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      selectedCases: this.prepSelectedCases(),
      selectedGroups: this.prepSelectedGroups(),
      selectedTaskingGroups: this.prepSelectedTaskingGroups(),
      selectedTab: props.groupsOnly ? GROUPS_INDEX : AIRMAN_INDEX,
      allGroupsSelected: false,
    };
  }

  navigationButtonPressed = ({ buttonId }) => {
    if (NavBar.handleButtonPress2(buttonId, this)) return;
  };

  componentDidMount() {
    Utils.trackScreen('Airforce', 'Select Cases for new events');
    Navigation.registerForButtonEvents(this);
  }
  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
  }

  prepSelectedCases = () => {
    return this.props.employerCases.map((c) => {
      return {
        label: c.name,
        id: c.caseId,
        checked: false,
      };
    });
  };

  prepSelectedGroups = (selectAll = false) => {
    const checked = selectAll ? !this.state.allGroupsSelected : false;
    return this.props.employerGroups?.map((g) => {
      return {
        label: g,
        id: g,
        checked,
      };
    });
  };

  prepSelectedTaskingGroups = () => {
    const checked = false;
    return this.props.employerTaskingGroups.map((g) => {
      return {
        label: g,
        id: g,
        checked,
      };
    });
  };

  handleResidentSelectValueChange = () => {};

  setSelectedCases = () => {
    InteractionManager.runAfterInteractions(() => {
      let selectedCases = {};
      if (this.state.selectedTab === AIRMAN_INDEX) {
        selectedCases.caseIds = this.state.selectedCases.filter((c) => c.checked).map((c) => c.id);
      } else if (this.state.selectedTab === GROUPS_INDEX) {
        selectedCases.squadrons = [];
        this.state.selectedGroups.forEach((g) => {
          if (g.checked) {
            selectedCases.squadrons.push(g.id);
          }
        });
      } else {
        selectedCases.taskingId = this.state.selectedTaskingGroup;
      }
      this.props.actions.setCalendarSelectedCases(selectedCases);
    });
  };

  handleSelectResident = (caseId, c) => {
    let selectedCases = this.state.selectedCases;
    if (!this.state.selectedCases.find((ca) => ca.id === caseId)) {
      selectedCases = [c].concat(selectedCases);
    }
    this.setState({
      selectedCases: selectedCases.map((c) => {
        if (c.id !== caseId) return c;

        return {
          ...c,
          checked: true,
        };
      }),
    });
    this.setSelectedCases();
    this.props.actions.caseInfoChanged(caseId);
  };

  handleSelectedGroupsChange = (selectedGroups) => {
    this.setState({ selectedGroups });
    this.setSelectedCases();
  };
  handleSelectedAirmenChange = (selectedCases) => {
    this.setState({ selectedCases });
    this.setSelectedCases();
  };
  selectAllGroups = () => {
    this.setState({
      selectedGroups: this.prepSelectedGroups(true),
      allGroupsSelected: !this.state.allGroupsSelected,
    });
    this.setSelectedCases();
  };

  renderSearch = () => {
    return (
      <ResidentSelect
        onValueChange={this.handleResidentSelectValueChange}
        onSelectCase={this.handleSelectResident}
        autoFocus={false}
        includeBeneficiaries={this.props.includeBeneficiaries}
        eventType={this.props.eventType}
      />
    );
  };

  handleTaskingGroupInputChange = (selectedTaskingGroup) => {
    if (!selectedTaskingGroup) return;

    this.setState({ selectedTaskingGroup }, this.setSelectedCases);
  };

  handleTabPress = (i) => {
    this.setState({ selectedTab: i });
  };

  sortedList(items) {
    return items.sort(function (a, b) {
      if (a.checked && !b.checked) {
        return -1;
      } else if (b.checked && !a.checked) {
        return 1;
      } else {
        if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
        else if (b.label.toLowerCase() > a.label.toLowerCase()) return -1;
        else return 0;
      }
    });
  }

  renderGroups = () => {
    return (
      <Container>
        <Pressable style={styles.allGroupsBtn} onPress={this.selectAllGroups}>
          <Text style={[THEME.linkStyle, styles.headerTextLink]}>
            {I18n.ce('employer.selectAllGroups')}
          </Text>
        </Pressable>
        <CheckButtonList
          items={this.sortedList(this.state.selectedGroups)}
          multi={true}
          scrollable={true}
          onValuesChanged={this.handleSelectedGroupsChange}
          buttonSize={'large'}
        />
        <View style={styles.bottomContainer}>
          {!this.props.hideNext && (
            <NextButton onPress={this.handleNextPressed} disabled={this.buttonEnabled()} />
          )}
        </View>
      </Container>
    );
  };

  renderTaskingGroups = () => {
    if (this.props.eventType === EVENT_TYPE_AIRFORCE_DEPLOYMENT) return null;

    return (
      <View style={[styles.container]}>
        <Container>
          <View style={THEME.inputsContainer}>
            <FormInput
              value={this.state.selectedTaskingGroup}
              label={I18n.ac_aec('airforce.taskingId')}
              multiline={false}
              onChangeText={this.handleTaskingGroupInputChange}
            />
          </View>
          <View style={styles.bottomContainer}>
            {!this.props.hideNext && (
              <NextButton onPress={this.handleNextPressed} disabled={this.buttonEnabled()} />
            )}
          </View>
        </Container>
      </View>
    );
  };

  renderAirmen = () => {
    return (
      <View style={[styles.container, styles.innerContentStyle]}>
        <Container>
          <CheckButtonList
            items={this.sortedList(this.state.selectedCases)}
            multi={true}
            scrollable={true}
            onValuesChanged={this.handleSelectedAirmenChange}
            buttonSize={'large'}
          />
          <View style={styles.bottomContainer}>
            {!this.props.hideNext && (
              <NextButton onPress={this.handleNextPressed} disabled={this.buttonEnabled()} />
            )}
          </View>
        </Container>
        {this.renderSearch()}
      </View>
    );
  };

  buttonEnabled = () => {};

  handleNextPressed = () => {
    this.setSelectedCases();

    if (this.props.openNextScreen) {
      this.props.openNextScreen(this.props.componentId);
      return;
    }

    if (this.props.eventType === EVENT_TYPE_AIRFORCE_DEPLOYMENT) {
      Navigation.openScreen(
        {
          screen: 'DeploymentForm',
          title: I18n.ac('airforce.deploymentInfo'),
          passProps: {
            onEventAdd: this.props.onEventAdd,
          },
        },
        this.props.componentId,
        false
      );
    }
  };

  render() {
    const props = this.props;

    const tabItems = [];
    if (!props.groupsOnly) {
      tabItems.push({
        index: AIRMAN_INDEX,
        label:
          this.props.eventType !== EVENT_TYPE_AIRFORCE_DEPLOYMENT
            ? I18n.ac_aec('employer.resident')
            : I18n.ac_aec('employer.serviceMember'),
      });
    }
    if (!props.airmenOnly) {
      tabItems.push({
        index: GROUPS_INDEX,
        label: I18n.ac('employer.groups'),
      });
      if (this.props.eventType !== EVENT_TYPE_AIRFORCE_DEPLOYMENT) {
        tabItems.push({
          index: TASKINGID_INDEX,
          label: I18n.ac('airforce.taskingId'),
        });
      }
    }

    return (
      <View style={THEME.container}>
        {!props.airmenOnly && (
          <TabMenu
            items={tabItems}
            selectedIndex={this.state.selectedTab}
            onPress={this.handleTabPress}
          />
        )}
        <View style={styles.container}>
          {this.state.selectedTab === GROUPS_INDEX && this.renderGroups()}
          {this.state.selectedTab === AIRMAN_INDEX && this.renderAirmen()}
          {this.state.selectedTab === TASKINGID_INDEX && this.renderTaskingGroups()}
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    ...THEME.containerAlt,
    // overflow: __WEB__ ? 'visible' : 'scroll',
  },
  innerContentStyle: {
    paddingTop: 60,
  },
  bottomContainer: {
    padding: 25,
    paddingBottom: 45,
    justifyContent: 'flex-end',
  },
  headerTextLink: {
    ...FONT.semibold,
    justifyContent: 'flex-end',
    textDecorationLine: 'underline',
  },
  allGroupsBtn: {
    paddingHorizontal: 30,
    paddingVertical: 15,
    borderBottomWidth: 1,
    borderColor: COLOR.accent,
  },
});

function mapStateToProps(state, ownProps) {
  let employerCases = getCasesForEmployer(state);
  if (!ownProps.includeBeneficiaries) {
    employerCases = employerCases.filter((c) => c.patient?.role !== BENEFICIARY);
  }
  const groupedPatients = getGroupedPatientsForEmployer(state);
  const groupedPatientsByTaskingID = getGroupedPatientsByTaskingIdForEmployer(state);
  const employerGroups = getGroupsForEmployer(state);
  const employerTaskingGroups = Object.keys(groupedPatientsByTaskingID);
  return {
    employerCases,
    employerGroups,
    groupedPatients,
    groupedPatientsByTaskingID,
    employerTaskingGroups,
    casesById: state.entities.cases,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        setCalendarSelectedCases,
        caseInfoChanged,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
  SelectCases
);
